import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const METRIC_LABELS = {
  queue_depth:        "Fila Pendente",
  send_success_rate:  "Taxa de Envio",
  recent_error_count: "Erros Recentes",
  last_event_at:      "Último Evento",
  last_send_at:       "Último Envio",
};

function fmt(key, value) {
  if (value == null) return "—";
  if (key === "send_success_rate") return `${Math.round(value * 100)}%`;
  if (key === "last_event_at" || key === "last_send_at") {
    return new Date(value).toLocaleString();
  }
  return String(value);
}

function MetricRow({ label, value }) {
  return (
    <div className="flex items-center justify-between py-1.5 border-b last:border-0">
      <span className="text-sm text-gray-700">{label}</span>
      <span className="text-sm font-medium text-gray-900">{value}</span>
    </div>
  );
}

export default function TenantMetricsPanel({ metrics }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold">Métricas</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {Object.entries(METRIC_LABELS).map(([key, label]) => (
          <MetricRow key={key} label={label} value={fmt(key, metrics[key])} />
        ))}
      </CardContent>
    </Card>
  );
}
